import type { RefObject } from 'react';
import type { FlatList, ScrollView } from 'react-native';

export type PaginatedListScrollRefs<T = unknown> = {
  flatListRef?: RefObject<FlatList<T> | null>;
  scrollViewRef?: RefObject<ScrollView | null>;
};

/** Lleva el listado (o el scroll exterior en layout wide) al inicio. */
export function scrollPaginatedListToTop<T = unknown>(
  refs: PaginatedListScrollRefs<T>,
  animated = false
): void {
  refs.flatListRef?.current?.scrollToOffset({ offset: 0, animated });
  refs.scrollViewRef?.current?.scrollTo({ y: 0, animated });
}
